import { NAME } from './constants';

export const FETCH_ITEM = `${NAME}/FETCH_ITEM`;
export const FETCH_ITEM_SUCCESS = `${NAME}/FETCH_ITEM_SUCCESS`;
export const FETCH_ITEM_FAILURE = `${NAME}/FETCH_ITEM_FAILURE`;

export const FETCH_PRESETS = `${NAME}/FETCH_PRESETS`;
export const FETCH_PRESETS_SUCCESS = `${NAME}/FETCH_PRESETS_SUCCESS`;
export const FETCH_PRESETS_FAILURE = `${NAME}/FETCH_PRESETS_FAILURE`;

export const FETCH_SYSTEMS_CATALOG = `${NAME}/FETCH_SYSTEMS_CATALOG`;
export const FETCH_SYSTEMS_CATALOG_SUCCESS = `${NAME}/FETCH_SYSTEMS_CATALOG_SUCCESS`;
export const FETCH_SYSTEMS_CATALOG_FAILURE = `${NAME}/FETCH_SYSTEMS_CATALOG_FAILURE`;

export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;

export const OPEN_MODAL = `${NAME}/OPEN_MODAL`;

export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SAVE_ITEM = `${NAME}/SAVE_ITEM`;
export const SAVE_ITEM_FAILURE = `${NAME}/SAVE_ITEM_FAILURE`;
export const SAVE_ITEM_SUCCESS = `${NAME}/SAVE_ITEM_SUCCESS`;

export const SAVE_PREFERENCE = `${NAME}/SAVE_PREFERENCE`;
export const SAVE_PREFERENCE_FAILURE = `${NAME}/SAVE_PREFERENCE_FAILURE`;
export const SAVE_PREFERENCE_SUCCESS = `${NAME}/SAVE_PREFERENCE_SUCCESS`;

export const SET_IS_NEW_RECORD = `${NAME}/SET_IS_NEW_RECORD`;
